import styled from 'styled-components';

export const SaveButtonContainer = styled.div`
  padding: 20px 10px;
  display: flex;
  justify-content: flex-end;

  border-top: 1px solid #e0e0e0;
`;
